import { render } from "./UnifiedChat.vue?vue&type=template&id=23918348&scoped=true"
import script from "./UnifiedChat.vue?vue&type=script&lang=js"
export * from "./UnifiedChat.vue?vue&type=script&lang=js"

import "./UnifiedChat.vue?vue&type=style&index=0&id=23918348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23918348"]])

export default __exports__